<template>
  <v-data-table
    :page="page"
    :pageCount="pageCount"
    :server-items-length="itemCount"
    :options.sync="options"
    :headers="headers"
    :items="employees"
    sort-by="Name"
    sort-asc
    class="elevation-1"
    :loading="isLoading"
    loading-text="Loading Staff"
    :search="searchQuery"
    v-if="!isAdmin"
  >
    <template v-slot:item.select="{ item }">
      <router-link
        :to="{ name: 'StaffInfo', params: { employeeID: item._id } }"
      >
        <v-btn x-small class="white--text" color="#2b3990"> select </v-btn>
      </router-link>
    </template>

    <template v-slot:item.Progress="{ item }">
      <v-progress-linear
        :background-opacity="0.3"
        :buffer-value="100"
        :height="25"
        :width="150"
        :rounded="true"
        :value="item.Progress"
      >
        <div v-if="item.Progress != null" color="white">
          {{ item.Progress }}%
        </div>
        <div v-else>0%</div>
      </v-progress-linear>
    </template>

    <template v-slot:item.VerificationStatus="{ item }">
      <v-chip
        class="ma-2"
        :color="item.VerificationStatus === 'Pending' ? 'yellow' : 'green'"
        x-small
      >
        <span
          :class="
            item.VerificationStatus === 'Pending'
              ? 'black--text'
              : 'white--text'
          "
          >{{ item.VerificationStatus }}</span
        >
      </v-chip>
    </template>

    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Staff</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchQuery"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="desktop"
          @input="debouncedFetchData"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-text-field
        v-model="search"
        clearable
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="search"
        class="mobile ml-5 mr-5 mb-3 mt-3"
        @input="debouncedFetchData"
      ></v-text-field>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="getEmployees()">Reset</v-btn>
    </template>
    <template v-slot:item.Name="{ item }">
      <span :class="getUserClass(item)">
        {{ item.Name }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";

const url = require("../../client_config/config").url;

export default {
  props: {
    programs: {
      type: Array,
      required: true,
    },
    employeeRole: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      headers: [
        {
          text: "Select Staff",
          align: "start",
          sortable: false,
          value: "select",
        },
        { text: "Name", value: "Name" },
        { text: "Phone", value: "PhoneNumber" },
        { text: "Email", value: "Email" },
        { text: "State", value: "State" },
        { text: "Position", value: "Role" },
        { text: "Status", value: "Status" },
        { text: "Program", value: "programDisplay" },
        { text: "Progress", value: "Progress" },
        { text: "Verification Status", value: "VerificationStatus" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: null,
      adddialog: false,
      editdialog: false,
      passdialog: false,
      editEmail: false,
      editEmployee: false,
      search: "",
      searchQuery: "",
      text: "",
      employees: [],
      staffID: "",
      employeeID: "",
      Role: localStorage.getItem("userRole"),
      userState: localStorage.getItem("userState"),
      page: 1,
      pageCount: 1,
      itemCount: 0,
      options: {},
      isLoading: true,
    };
  },

  computed: {
    queryParams() {
      const companyIds = localStorage.getItem('userCompanies');
      let {page, itemsPerPage, sortBy, sortDesc} = this.options;
      const sortField = sortBy ? sortBy[0] : 'Name';
      const sortDirection = sortDesc ? (sortDesc[0] ? 1:-1) : 1;

      page = page || 1;
      itemsPerPage = itemsPerPage || 10;

      let params = {
        page: page,
        limit: itemsPerPage,
        companyIds: companyIds,
        status:'active',
        search: this.searchQuery,
        sortField: sortField,
        sortDirection: sortDirection,
        state: localStorage.getItem("userState"),
      };

      return params;
    },
  },

  watch: {
    options: {
      handler() {
        this.getEmployees();
      },
      deep: true,
    },
    searchQuery: "debouncedFetchData",
  },

  async created() {
    await this.getEmployees();
  },

  methods: {
    initialize() {
      this.employees = [];
    },

    validate() {
      return this.$refs.form.validate();
    },

    debouncedFetchData: debounce(function () {
      this.options.page = 1; // Reset to the first page on new search
      this.getEmployees();
    }, 1000),

    getEmployees() {
      this.isLoading = true;

      if (this.employeeRole == "NotAdmin") {
        this.headers = [
          { text: "Staff Name", align: "start", sortable: true, value: "Name" },
          { text: "Phone", value: "PhoneNumber" },
          { text: "Email", value: "Email" },
        ];
      }

      axios
        .get(`${url}/employees/staff/pagination`, { params: this.queryParams })
        .then((res) => {
          this.employees = res.data.employees.map(item => ({
            ...item,
            programDisplay: item.Program?.length
              ? item.Program.filter(p => p?.trim()).join(', ')
              : 'N/A', 
          }));

          this.itemCount = res.data.totalCount;
        })
        .finally(() => (this.isLoading = false));
    },

    close() {
      this.adddialog = false;
      this.editdialog = false;
      this.passdialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    getUserClass(user) {
      return user.RequiresSupervision ? "red-header" : "";
    },
  },
};
</script>